import React, { StyleHTMLAttributes } from 'react';
import styles from './styles.less';
import { Brand_Logo } from '@/utils/uiHelper';

const BrandLoading = () => {
  return <img alt={'veeyung'} draggable={false} src={Brand_Logo} className={styles.brand} />;
};

const typesEnum = {
  spin: <BrandLoading />,
};

export type LoadingProps = Partial<{
  /**图标类型 */
  type: 'spin';
  /**文本 */
  text: string;
  /**容器样式 */
  style: StyleHTMLAttributes<HTMLDivElement>;
  /**className */
  className: string;
  /**自定义图标 */
  indicator: React.ReactNode;
  /**忙碌状态， false 则不渲染 */
  busy: boolean;
  /**作为容器组件时遮罩的透明度 */
  overlayOpacity: number;
  /**文本样式 */
  textStyle: StyleHTMLAttributes<HTMLSpanElement>;
  children: React.ReactNode;

  fullScreen?: boolean;
}>;

const Loading: React.FC<LoadingProps> = ({
  type = 'spin',
  text,
  style = {},
  className = '',
  indicator,
  children,
  busy = true,
  overlayOpacity = 0,
  textStyle = {},
  fullScreen = false,
}: LoadingProps) => {
  {
    const loadingIndicator = indicator ? indicator : typesEnum[type];
    const asContainer = !!children;

    const asContainerStyle = asContainer
      ? ({
          position: 'relative',
        } as StyleHTMLAttributes<HTMLDivElement>)
      : ({} as StyleHTMLAttributes<HTMLDivElement>);

    let textBrightness = overlayOpacity;

    if (textBrightness > 0.5) {
      textBrightness = 0.9;
    } else {
      textBrightness = 0.1;
    }

    return (
      <div className={className} style={Object.assign(asContainerStyle, style)}>
        {busy && (
          <span
            className={`${styles.container} ${asContainer ? styles.wrapper : ''} ${
              fullScreen ? styles.fullScreen : ''
            }`}
            style={
              asContainer
                ? {
                    background: `rgba(0,0,0, ${overlayOpacity})`,
                  }
                : {}
            }>
            {loadingIndicator}
            <span
              className={styles.text}
              style={Object.assign(
                asContainer
                  ? {
                      color: `hsl(0,0%,${textBrightness * 100}%)`,
                    }
                  : {},
                textStyle
              )}>
              {text}
            </span>
          </span>
        )}
        {children}
      </div>
    );
  }
};

export default Loading;
